
<script>
import axios from 'axios';
import { Line } from 'vue-chartjs'

export default {
    extends: Line,
    props: ['req'],
    watch: { 
        req: function(newVal) { // watch it
            axios
                .get('http://magnum-dev.presstoday.com/'+newVal)
                .then(response => {
                    this.info = response.data.data
                    //console.log(response.data.data);
                    console.log("watch()")
                    this.renderChart(this.info, this.opts);
                }
            )
        }
    },
    data() {
        return {
            info: null,
            opts: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [
                        {
                            stacked: false
                        }
                    ]
                }
            }
        };
    },
    mounted () {
        axios
            .get('http://magnum-dev.presstoday.com/'+this.req)
            .then(response => {
                this.info = response.data.data
                console.log("mounted()")
                //console.log(response.data.data);
                this.renderChart(this.info, this.opts);
            }
        )
    }
}
</script>